import type { ReadonlySignal } from "@preact/signals";

interface InputErrorProps {
  name: string;
  errors: ReadonlySignal<[string, ...string[]] | null>;
}

export function InputError({ name, errors }: InputErrorProps) {
  const first = errors.value?.[0];
  if (!first) return null;
  return <div id={`${name}-error`} class="text-xs text-theme-destructive">{first}</div>;
}
